/** Admin users desk — filter labels and helpers. */

export const DESK_VIEWS = [
  { id: "all", label: "All users", hint: "Full directory" },
  { id: "staff", label: "Staff & agents", hint: "Non-player roles" },
  { id: "banned", label: "Banned review", hint: "Suspended accounts" },
];

export const STATUS_FILTERS = [
  { value: "all", label: "All status" },
  { value: "active", label: "Active" },
  { value: "banned", label: "Banned" },
];

export const ROLE_FILTERS = [
  { value: "all", label: "All roles" },
  { value: "user", label: "User" },
  { value: "agent", label: "Agent" },
  { value: "ambassador", label: "Ambassador" },
  { value: "partner", label: "Partner" },
  { value: "admin", label: "Admin" },
  { value: "super_admin", label: "Super admin" },
];

export const SORT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "name", label: "Name A–Z" },
  { value: "cash", label: "Highest cash" },
];

export const STAFF_ROLES = new Set(["agent", "ambassador", "partner", "admin", "super_admin"]);

export function applyDeskFilter(users, desk) {
  const list = users || [];
  if (desk === "staff") return list.filter((u) => STAFF_ROLES.has(u?.role));
  if (desk === "banned") return list.filter((u) => u?.isBanned);
  return list;
}

export function sortUsers(users, sortKey) {
  const list = [...(users || [])];
  if (sortKey === "oldest") {
    return list.sort((a, b) => new Date(a?.createdAt || 0) - new Date(b?.createdAt || 0));
  }
  if (sortKey === "name") {
    return list.sort((a, b) => String(a?.name || "").localeCompare(String(b?.name || "")));
  }
  if (sortKey === "cash") {
    return list.sort((a, b) => (Number(b?.CASH) || 0) - (Number(a?.CASH) || 0));
  }
  return list.sort((a, b) => new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0));
}

export function buildFetchParams({ desk, search, roleFilter, statusFilter, page = 1, limit = 20 }) {
  let status = statusFilter === "all" ? "" : statusFilter;
  if (desk === "banned") status = "banned";

  return {
    page,
    limit,
    search: String(search || "").trim(),
    role: roleFilter === "all" ? "" : roleFilter,
    status,
  };
}

export function countStaffUsers(users) {
  return (users || []).filter((u) => STAFF_ROLES.has(u?.role)).length;
}
